import React, { useEffect, useState } from 'react'
import { Box, Button, Card, Grid, Typography, makeStyles } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import Modal from '../component/Modal'

const useStyles = makeStyles((theme) => ({
  container: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f5f5f5"
  },
  card: {
    padding: "40px",
    textAlign: "center",
    maxWidth: "500px"
  }
}))

function RestrictedAccess() {
  const classes = useStyles()
  const history = useHistory()
  const [showModal, setShowModal] = useState(true)
  const [userEmail, setUserEmail] = useState('')

  useEffect(() => {
    const tempData = localStorage.getItem('temporaryUserData')
    if (tempData) {
      const userData = JSON.parse(tempData)
      setUserEmail(userData.email)
    } else {
      // If no temporary data, redirect to login
      history.push('/login')
    }
  }, [history])

  const handleLogout = () => {
    localStorage.clear()
    history.push('/login')
  }

  const noOp = () => {} // Do nothing - prevents closing

  return (
    <>
      <Modal
        status={showModal}
        title="Access Denied"
        closeHandler={noOp}
        modalPaper={{
          backgroundColor: "#fff3cd",
          border: "1px solid #ffc107"
        }}
        maxWidth="xs"
      >
        <Box style={{ padding: "20px", textAlign: "center" }}>
          <Typography variant="h6" style={{ color: "#856404", marginBottom: "15px", fontSize: "18px" }}>
            ⚠️ Access Restricted
          </Typography>
          <Typography style={{ color: "#856404", fontSize: "14px", marginBottom: "10px" }}>
            Your email address <strong>{userEmail}</strong> is not authorized to access this portal.
          </Typography>
          <Typography style={{ color: "#856404", fontSize: "13px", marginTop: "15px", marginBottom: "15px" }}>
            This account is no longer in use. Feel free to get in touch with us on <strong>8423684311</strong>
          </Typography>
          <Button
            onClick={handleLogout}
            variant="contained"
            color="secondary"
            style={{ marginTop: "25px" }}
          >
            Logout
          </Button>
        </Box>
      </Modal>
    </>
  )
}

export default RestrictedAccess
